import types from './types'
import generateUniqueId from './uniq-id'

const DEFAULT_TIMEOUT = 3000

const dismissAction = (notification) => ({
  type: types.DISMISS_SNACKBAR_ITEM,
  payload: notification,
})

const addItem = (message, { id = generateUniqueId(), timeout = false, actionText } = {}) => {
  return (dispatch) =>
    dispatch({
      type: types.ADD_SNACKBAR_ITEM,
      payload: {
        key: id,
        action: actionText,
        dismissAfter: timeout,
        message,
      },
    })
}

const addSnackbarItem = (message, timeout = DEFAULT_TIMEOUT) => {
  return addItem(message, { timeout })
}
const dismissSnackbarItem = (notification) => {
  return (dispatch) => dispatch(dismissAction(notification))
}

export default {
  addSnackbarItem,
  addItem,
  dismissSnackbarItem,
}
